import { Component } from '@angular/core';
import { ConstantData } from 'src/app/services/constants';
import { ToasterData, TosterMsgType } from 'src/app/services/model';
import { ToasterService } from 'src/app/services/toaster.service';

@Component({
  selector: 'app-toaster',
  templateUrl: './toaster.component.html',
  styleUrls: ['./toaster.component.scss']
})
export class ToasterComponent {
  toasterData!: ToasterData;
  className:string = 'error';
  tosterCloseIcon = ConstantData.tosterCloseIcon;
  warnIcon = ConstantData.tosterWarningIcon;
  get isAlert ():boolean {
    return this.className === 'alert';
   }
  constructor(private toasterService: ToasterService) {

  }
  closeMsg(){
    this.toasterData.callBack && this.toasterData.callBack();
    this.toasterService.hide();
  }

  ngOnInit() {
    this.toasterService.toasterState.subscribe((data: ToasterData) => {
      this.toasterData = data;
      this.className = this.getClassName(data.type);
    })
  }

  getClassName(value:TosterMsgType){
    switch(value){
      case TosterMsgType.ERROR: 
      return 'error';
      case TosterMsgType.SUCCESS: 
      return 'success'; 
      case TosterMsgType.WARNING:
      return 'alert';
    }
  }
}
